import { useEffect, useState } from 'react';
import { useToastStore } from '@/store/auth';

export function GlobalToast() {
  const storeMessage = useToastStore((s) => s.message);
  const storeVariant = useToastStore((s) => s.variant);

  const [displayMessage, setDisplayMessage] = useState<string | null>(null);
  const [displayVariant, setDisplayVariant] = useState<'success' | 'error'>('success');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (storeMessage) {
      setDisplayMessage(storeMessage);
      setDisplayVariant(storeVariant);
      const t = setTimeout(() => setVisible(true), 16);
      return () => clearTimeout(t);
    } else {
      setVisible(false);
      const t = setTimeout(() => setDisplayMessage(null), 300);
      return () => clearTimeout(t);
    }
  }, [storeMessage, storeVariant]);

  if (!displayMessage) return null;

  const isError = displayVariant === 'error';

  return (
    <div
      className="pointer-events-none fixed left-1/2 top-2.5 z-50 -translate-x-1/2 transition-[transform,opacity] duration-300 ease-out"
      style={{
        transform: `translateX(-50%) translateY(${visible ? '0' : '-120%'})`,
        opacity: visible ? 1 : 0,
      }}
    >
      <div className="inline-flex w-max max-w-[90vw] items-center gap-2 rounded-full bg-black/90 px-3.5 py-2 text-white shadow-lg">
        {isError ? (
          <img src="/home/icons/toastError.svg" alt="" aria-hidden width={18} height={18} className="shrink-0" />
        ) : (
          <TickIcon />
        )}
        <span className="text-[12px] font-semibold leading-snug">{displayMessage}</span>
      </div>
    </div>
  );
}

function TickIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className="shrink-0">
      <circle cx="9" cy="9" r="9" fill="#22C55E" />
      <path
        d="M5.5 9l2.5 2.5 4.5-5"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

